import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  credentialId: '',
  resource: 'constituent',
  action: 'getConstituent',
  constituentId: '',
  emailAddress: '',
  searchFor: '',
  constituentData: '',
  transactionId: '',
  transactionData: '',
  activityId: '',
  activityData: '',
  listId: '',
  page: 1,
  pageSize: 100,
  lookupType: '',
};

export default defaults;
